<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Pickup
        ref="pickup"
        :form-data="formData.pickupData"
      />
    </el-card>
  </div>
</template>
<script>
import Pickup from '@/components/Application/Manage/Carriers/Carrier/Pickup'
export default {
  components: {
    Pickup
  },
  data () {
    return {
      title: 'Pickup',
      breadcrumb: {
        name: 'Pickup',
        route: { name: 'manage-carriers-carrier-configurations-pickup' }
      },
      isSaving: false,
      isLoading: false,
      carrier: [],
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      formData: {
        pickupData: {
          pickupType: null,
          pickupTemplate: null,
          pickupCutoff: null
        }
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
      }).then(res => {
        this.carrier = res
        this.formData.pickupData.pickupCutoff = res.pickup_cutoff
        this.formData.pickupData.pickupTemplate = res.pickup_template
        this.formData.pickupData.pickupType = res.pickup_type
      })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.pickup_cutoff = this.formData.pickupData.pickupCutoff
      this.carrier.pickup_template = this.formData.pickupData.pickupTemplate
      this.carrier.pickup_type = this.formData.pickupData.pickupType
      this.$refs.pickup.$refs.form.validate((valid) => {
        if (valid) {
          this.carrier.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    }
  }
}
</script>
